import React, { useRef, useState } from 'react'
import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import styles from './TaskNotesController.module.sass'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import { useReload, useInbox } from 'store'
import { useRecoilState } from 'recoil'
import { taskNote } from 'store/atoms'

import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator'
import { translateErrorMessage } from 'hooks/useSubmitTask'

const TaskNotesController = (props) => {
	const { data, requisition, isNotesLoading } = props
	const { i18n, pushNotification, expireSession } = useGlobal()
	const { reloadInbox } = useInbox()
	const reload = useReload()
	const [submitting, setSubmitting] = useState(null)
	const inputRef = useRef(null)

	const [addNote, setAddNote] = useState(false)
	const [editMode, setEditMode] = useState(false)

	const [noteValue, setNoteValue] = useRecoilState(taskNote)
	//console.log("🚀 ~ TaskNotesController ~ noteValue:", noteValue)

	const hasNotes = !!data?.taskNote || data?.taskNote?.length > 0
	//console.log("🚀 ~ TaskNotesController ~ data?.taskNote:", data?.taskNote)
	//console.log("🚀 ~ TaskNotesController ~ hasNotes:", hasNotes)

	const onSubmit = (deleteNote = false) => {
		if (submitting || noteValue === '') {
			return
		}

		setSubmitting(true)

		const endpoint = `${API_URL}/api/tasks/${data.id}/notes`

		fetch(
			endpoint,
			fetchOptions({
				method: 'PUT',
				body: { notes: deleteNote ? '' : noteValue },
			})
		)
			.then(async (r) => {
				if (r.ok) {
					setSubmitting('success')
					reload([
						'/tasks/me?state=Created',
						'/tasks/me?state=Postponed',
						'/tasks/stats',
					])
					setSubmitting(false)

					if (deleteNote) {
						setNoteValue('')
						pushNotification(
							undefined,
							'success',
							i18n`Note deleted successfully!`
						)
					} else {
						pushNotification(
							undefined,
							'success',
							i18n`Note added successfully!`
						)
					}

					reload([
						`clinical_processes/${requisition?.processId}/requisitions/${requisition?.id}/notes`,
						`/clinical_processes/${data?.processId}/tasks`,
					])

					reloadInbox()
				} else {
					const res = await parseJSONContent(r)
					setSubmitting(false)
					pushNotification(undefined, 'error', await res.message)
				}
			})
			.catch((e) => {
				if (e.status === '401' || e.status === 401) {
					expireSession()
				}
				const errorMessage = translateErrorMessage(e, i18n)

				setSubmitting(false)
				pushNotification(undefined, 'error', errorMessage)
			})
	}

	const handleNoteClick = (e) => {
		e.preventDefault()
		setAddNote(true)
		setEditMode(true)
		inputRef.current?.focus()
	}

	return (
		<div className={styles['notes-root']}>
			{isNotesLoading && (
				<LoadingIndicator
					className={`${styles['inner-loading-indicator']} ${styles['--notes']}`}
				/>
			)}
			<VStack className={styles['notes-root']}>
				<button
					className={`${styles['notes-add-button']} ${
						hasNotes || addNote
							? styles['--hide-button']
							: styles['--show-button']
					}`}
					onClick={handleNoteClick}
				>
					<Icon width='20px' height='20px' name='plus-alt' />
					<small>{i18n`Add Note`}</small>
				</button>

				<div
					className={`${styles['note-container']} ${
						hasNotes || addNote
							? editMode
								? styles['--show-note-container']
								: styles['--from-maximized-to-without-options']
							: styles['--hide-note-container']
					}
				`}
				>
					<VStack>
						<HStack className={styles['note-text-container']}>
							<Icon width='20px' height='20px' name='note'></Icon>
							<VStack className={styles['text-container']}>
								<h5>{i18n`Note`}</h5>
								<TextInput
									ref={inputRef}
									className={`${styles['notes-input']} ${
										noteValue ? styles['--has-text'] : ''
									}`}
									multiline={true}
									placeholder={i18n`Add a note`}
									rows={5}
									noResize
									onClick={() => {
										setEditMode(true)
										setAddNote(true)
									}}
									onChange={(e) => {
										setNoteValue(e.target.value)
									}}
									value={noteValue}
								/>
							</VStack>
						</HStack>
					</VStack>
					<HStack
						className={`${styles['notes-buttons-container']} ${
							editMode
								? styles['--show-buttons']
								: styles['--hide-buttons']
						}`}
					>
						{data?.taskNote === noteValue && noteValue?.length ? (
							<button
								className={styles['notes-button']}
								onClick={() => {
									setAddNote(false)
									setEditMode(false)
									onSubmit(true)
								}}
							>
								<small>{i18n`Delete`}</small>
							</button>
						) : (
							<button
								className={styles['notes-button']}
								onClick={() => {
									setEditMode(false)

									if (!hasNotes) {
										setAddNote(false)
										setNoteValue('')
									} else {
										setNoteValue(data?.taskNote)
									}
								}}
							>
								<small>{i18n`Cancel`}</small>
							</button>
						)}

						<button
							className={styles['notes-button']}
							onClick={() => {
								setEditMode(false)
								onSubmit()
							}}
						>
							<small>{i18n`Save`}</small>
						</button>
					</HStack>{' '}
				</div>
			</VStack>
		</div>
	)
}

export default TaskNotesController
